<template>
  <div>
    <div class="range-filter__placeholder">{{ placeholder }}</div>
    <el-slider
       v-model="value"
       ref="slider"
       :range="true"
       :max="max"
       :disabled="disabled"
       :format-tooltip="format"
       @change="handleChange" />
  </div>
</template>

<script>
import Filter from './filter.js'
import customGraphApiAware from '../mixins/customGraphApiAware'

export default {
  mixins: [Filter, customGraphApiAware],
  computed: {
    max () {
      return Math.max(0, this.values.length - 1)
    }
  },
  created () {
    this.load().then(() => {
      this.value = [0, this.max]
      this.updateDefault().then(() => {
        this.handleChange(this.value)
      })
    })
  },
  methods: {
    format (val) {
      return typeof this.values[val] === 'undefined' ? '' : this.values[val].caption
    },
    async setValues (values, clearDefault) {
      if (!values) {
        return Promise.resolve()
      }
      this.clearDefault = clearDefault || true
      await this.load().then(() => {
        let min = null
        let max = null
        values.forEach(val => {
          const index = this.values.findIndex(v => v.uniqueName === val.uniqueName)
          if (index !== -1 && (min === null || min > index)) {
            min = index
          }
          if (index !== -1 && (max === null || max < index)) {
            max = index
          }
        })
        if (min === null) {
          min = 0
        }
        if (max === null) {
          max = this.max
        }
        this.value = [min, max]
      })
      return Promise.resolve()
    },
    handleChange (v) {
      this.$emit('change', {
        dimension: this.api.dimension.uniqueName(this.data.value),
        values: v[1] + 1 - v[0] === this.values.length ? [] : this.values.slice(v[0], v[1] + 1)
      })
    }
  }
}
</script>

<style lang="less" scoped>
    .range-filter__placeholder {
        padding: 0;
        margin: 0;
        color: rgb(64, 158, 255);
        font-size: 1em;
        text-align: center;
        line-height: 1em;
        min-width: 150px;
    }
</style>
<style lang="less">
.widget .el-slider {
    min-width: 150px;
    .el-slider__button-wrapper {
        z-index: 0;
    }

}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/filter/RangeFilter.vue